import React, { PropsWithChildren } from 'react';

import { Divider } from '@mui/material';

import useStyles from './styles';

interface Props {
    className?: string;
}

const SubMenu: React.FC<PropsWithChildren<Props>> = ({ className, children }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            {React.Children.toArray(children).map((item, index) => (
                <React.Fragment key={index}>
                    {index === 0 ? null : <Divider flexItem orientation="vertical" className={classes.divider} />}
                    {item}
                </React.Fragment>
            ))}
        </div>
    );
};

export default SubMenu;
